import MarkdownRenderer from "@memorang/ui/components/MarkdownRenderer";
import { useDevice } from "@memorang/ui/useDevice";
import { useMemo } from "react";
import { ScrollView } from "react-native";

type Props = {
	sessionAnalysisData: string;
	bottomContent?: React.ReactNode;
	appFont?: string;
	fontSize?: number;
};
const FullReportContent = ({
	sessionAnalysisData,
	bottomContent,
	appFont,
	fontSize,
}: Props) => {
	const { isMobile } = useDevice();
	const cleanedSessionAnalysisData = useMemo(
		() => sessionAnalysisData.replace(/\s{2}\n/g, "\n"), // Fixes excessive bottom spacing by removing double newlines from session analysis text
		[sessionAnalysisData],
	);

	return (
		<ScrollView
			contentContainerStyle={{
				paddingBottom: 24,
				paddingHorizontal: isMobile ? 0 : 24,
				paddingTop: isMobile ? 0 : 8,
			}}
		>
			<MarkdownRenderer
				variant="explanation"
				text={cleanedSessionAnalysisData}
				appFont={appFont}
				fontSize={fontSize}
				paragraphMarginVertical={6}
			/>
			{bottomContent}
		</ScrollView>
	);
};

export default FullReportContent;
